import m from "mithril";
import MessageProvider from "../../../MessageProvider"
import DateRangeComponent from "../DateRangeComponent"
import { getValueByLang } from "../../../Utils";
import './SearchBookingFormComponent.css'
import '../../common/ToolTip.css';
import BookingSearchFormState, { BookingLookupResultState } from "../../../states/BookingSearchFormState";

interface Attrs {
    messageProvider: MessageProvider;
    bookingSearchFormState: BookingSearchFormState;
    bookingLookupResultState: BookingLookupResultState;
    isOnDesktop: boolean,
    isOpeningDialog?: boolean,
    onSearchClick: () => void;
    onLocationClick: () => void;
    onDateRangePickerClick: () => void;
    onEmailOrPhoneChange: (emailOrPhone: string) => void;
}

let showRequiredLocationMessage = false;
let showRequiredDateRangeMessage = false;
let showRequiredEmailOrPhoneMessage = false;
let isSearched = false;
let emailOrPhoneValue = "";

const SearchBookingFormComponent: m.Component<Attrs> = {
    oninit(vnode) {
        showRequiredLocationMessage = false;
        showRequiredDateRangeMessage = false;
        showRequiredEmailOrPhoneMessage = false;
        emailOrPhoneValue = vnode.attrs.bookingSearchFormState.emailOrPhone;
    },
    onupdate(vnode) {
        isSearched = false;
    },
    view(vnode) {
        const { messageProvider, bookingSearchFormState, bookingLookupResultState, onSearchClick, onLocationClick, onDateRangePickerClick, onEmailOrPhoneChange } = vnode.attrs;

        function updateRequiredMessageState() {
            showRequiredLocationMessage = !vnode.attrs.isOpeningDialog && !vnode.attrs.bookingSearchFormState.location;
            showRequiredDateRangeMessage = !showRequiredLocationMessage && !vnode.attrs.isOpeningDialog && !vnode.attrs.bookingSearchFormState.checkInDate;
            showRequiredEmailOrPhoneMessage = !showRequiredLocationMessage && !showRequiredDateRangeMessage && !vnode.attrs.isOpeningDialog && !vnode.attrs.bookingSearchFormState.emailOrPhone;
        }

        return m("div", { class: "bg-white" }, [
            m("form.mb-0",  [
                m("div.row mt-1", [
                    m("div.col-md-3 col-12", [
                        m("div", {
                            class: showRequiredLocationMessage? "p-2 shadow-sm rounded clickable border-secondary border mb-4": "p-2 shadow-sm rounded clickable border mb-4",
                            id: "location-selection",
                            onclick: function (event) {
                                event.preventDefault();
                                onLocationClick()
                                showRequiredLocationMessage = false;
                                document.body.style.overflow = "auto";
                                document.getElementById('custom-scroll-id')!.classList.remove('custom-scroll');
                            }
                        }, [
                            m("i.bi bi-geo-alt text-secondary"),
                            (bookingSearchFormState.location) ?
                                m("span", { class: "pl-2" },
                                    (bookingSearchFormState.location.type.toString() == "ATTRACTION") ?
                                        [
                                            getValueByLang(bookingSearchFormState.location.name, messageProvider.getCurrentLang()),
                                            m("small.text-muted", " (" + messageProvider.get("nearby") + ")")
                                        ] :
                                        getValueByLang(bookingSearchFormState.location.name, messageProvider.getCurrentLang())
                                ) :
                                m("span", { class: "pl-2 text-muted" }, messageProvider.get("location"))
                        ]),
                        showRequiredLocationMessage?
                        m("div.tooltip",
                            m("span.tooltiptext", messageProvider.get("required_destination"))
                        ):null
                    ]),
                    m("div.col-md-3 col-12 mb-4", [
                        m(DateRangeComponent, {
                            showHightLight: showRequiredDateRangeMessage,
                            checkin: bookingSearchFormState.checkInDate,
                            checkout: bookingSearchFormState.checkOutDate,
                            checkinPlaceholder: messageProvider.get("checkin_date"),
                            checkoutPlaceholder: messageProvider.get("checkout_date"),
                            singularNightLabel: messageProvider.get("night"),
                            pluralNightLabel: messageProvider.get("nights"),
                            onDateRangePickerClick: function () {
                                onDateRangePickerClick()
                                showRequiredDateRangeMessage = false;
                                document.body.style.overflow = "auto";
                                document.getElementById('custom-scroll-id')!.classList.remove('custom-scroll');
                            }
                        }),
                        showRequiredDateRangeMessage?
                        m("div.tooltip",
                            m("span.tooltiptext", messageProvider.get("required_dates"))
                        ):null
                    ]),
                    m("div.col-md-4 col-12 mb-2", [
                        m("div.input-group input-group-default mb-3 rounded", [
                            m("span.input-group-text", {id: "inputGroup-sizing-default"}, 
                                m("i.bi bi-envelope text-secondary")
                            ),
                            m("input", {
                                    type: "text",
                                    class: "custom-form-control form-control",
                                    "aria-label": "Sizing example input",
                                    "aria-describedby": "inputGroup-sizing-sm",
                                    placeholder: messageProvider.get("email_or_phone"),
                                    value: emailOrPhoneValue,
                                    oninput: (event) => {
                                        emailOrPhoneValue = event.target.value;
                                    },
                                    onchange: (event) => {
                                        onEmailOrPhoneChange(event.target.value);
                                    },
                                    onfocus: function(event) {
                                        document.body.style.overflow = "hidden";
                                        document.getElementById('custom-scroll-id')!.classList.add('custom-scroll');
                                    }
                            })
                        ]),
                        showRequiredEmailOrPhoneMessage?
                        m("div.tooltip",
                            m("span.tooltiptext", messageProvider.get("required_email_or_phone"))
                        ): null,
    
                        bookingSearchFormState.emailOrPhone != undefined && !vnode.attrs.bookingSearchFormState.isCorrectEmailOrPhoneFormat(bookingSearchFormState.emailOrPhone).isCorrect?
                        m("div.tooltip",
                            m("span.tooltiptext", 
                                (vnode.attrs.bookingSearchFormState.isCorrectEmailOrPhoneFormat(bookingSearchFormState.emailOrPhone).searchWithType == 'EMAIL')?
                                messageProvider.get("require_correct_email_format"): messageProvider.get("require_myanmar_ph_number"))
                        ):null
                    ]),
                    m("div.col-md-2 col-12 mb-1", [
                        (!isSearched)?
                        [
                            m("button", {
                                class: "text-white btn btn-block btn-primary shadow-sm mmd-ripple raised pt-2 pb-2 rounded",
                                onclick: function (event) {
                                    event.preventDefault();
                                    updateRequiredMessageState();
                                    if(vnode.attrs.bookingSearchFormState.isValid()){
                                        document.body.style.overflow = "auto";
                                        document.getElementById('custom-scroll-id')!.classList.remove('custom-scroll');
                                        isSearched = true;
                                        onSearchClick();
                                    }
                                }
                            }, m("i.bi bi-search pr-2"), m("strong", messageProvider.get("booking_search")))
                        ]:
                        [
                            m("button", {
                                "type":"button",
                                class:"text-white btn btn-block btn-primary shadow-sm mmd-ripple raised pt-2 pb-2 rounded",
                                disabled: true
                            }, [
                                m("span", {
                                    "role":"status",
                                    class:"spinner-border spinner-border-sm mr-1"
                                }),
                                m("span",  messageProvider.get("booking_search"))
                            ])
                        ]
                        
                    ])

                ])
            ]),
            (bookingLookupResultState == 'NO_RELATED_BOOKING')?
            m("div.text-muted", m("small", messageProvider.get("no_booking_related_message"))):null
        ])
    }
};

export default SearchBookingFormComponent;

